import { Box, Typography, Stack, Link, Divider } from "@mui/material";

export default function DashboardFooter() {
  const year = new Date().getFullYear();

  return (
    <Box sx={{ mt: 6 }}>
      <Divider sx={{ mb: 2 }} />

      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        alignItems={{ xs: "flex-start", sm: "center" }}
        justifyContent="space-between"
      >
        {/* LEFT */}
        <Typography variant="body2" color="text.secondary">
          © {year} <b>CBT Nova</b>. All rights reserved.
        </Typography>

        {/* RIGHT */}
        <Stack
          direction="row"
          spacing={2}
          flexWrap="wrap"
          sx={{ fontSize: "0.85rem" }}
        >
          <Link
            href="/dashboard/pricing"
            underline="hover"
            color="inherit"
          >
            Pricing
          </Link>

          <Link
            href="/dashboard/my-subscriptions"
            underline="hover"
            color="inherit"
          >
            My Subscription
          </Link>

          <Link
            href="/terms"
            underline="hover"
            color="inherit"
          >
            Terms
          </Link>

          <Link
            href="/privacy"
            underline="hover"
            color="inherit"
          >
            Privacy
          </Link>

          <Link
            href="/contact"
            underline="hover"
            color="inherit"
          >
            Support
          </Link>
        </Stack>
      </Stack>
    </Box>
  );
}
